export const columnsDepartment = {
  type: 'Department',
  fields: [
    {
      queryFragment: `name`,
      label: 'Name'
    }
  ]
}
